import { loadRealTimeImagePreviewAPI } from '@/service';
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { RealTimeImagePreviewRequest } from '@model/image/RealTimeImagePreviewRequest';

const loadRealtimeImagePreviewBaseQueryKey = 'loadRealtimeImagePreview';
const loadRealtimeImagePreviewQueryKey = (request: RealTimeImagePreviewRequest) => [
  loadRealtimeImagePreviewBaseQueryKey,
  request,
];

const loadRealtimeImagePreviewFetchFunction = loadRealTimeImagePreviewAPI;

export const useLoadRealtimeImagePreviewQuery = (
  request: RealTimeImagePreviewRequest,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: loadRealtimeImagePreviewQueryKey(request),
    queryFn: () => loadRealtimeImagePreviewFetchFunction(request),
    placeholderData: keepPreviousData,
    enabled,
  });
};
